var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2402 10.5C18.2402 10.0858 18.576 9.75 18.9902 9.75H20.5002C23.9453 9.75 26.7502 12.5667 26.7502 16C26.7502 19.4451 23.9336 22.25 20.5002 22.25H18.9902C18.576 22.25 18.2402 21.9142 18.2402 21.5C18.2402 21.0858 18.576 20.75 18.9902 20.75H20.5002C23.1069 20.75 25.2502 18.6149 25.2502 16C25.2502 13.3933 23.1151 11.25 20.5002 11.25H18.9902C18.576 11.25 18.2402 10.9142 18.2402 10.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 16C5.25 12.5558 8.05579 9.75 11.5 9.75H13C13.4142 9.75 13.75 10.0858 13.75 10.5C13.75 10.9142 13.4142 11.25 13 11.25H11.5C8.88421 11.25 6.75 13.3842 6.75 16C6.75 18.6067 8.8851 20.75 11.5 20.75H13C13.4142 20.75 13.75 21.0858 13.75 21.5C13.75 21.9142 13.4142 22.25 13 22.25H11.5C8.0549 22.25 5.25 19.4333 5.25 16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 16C11.25 15.5858 11.5858 15.25 12 15.25H20C20.4142 15.25 20.75 15.5858 20.75 16C20.75 16.4142 20.4142 16.75 20 16.75H12C11.5858 16.75 11.25 16.4142 11.25 16Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.19e751e7.svg";
export { ForwardRef as ReactComponent };